(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    class ProductGallery extends HTMLElement {

    #highlightSelectedThumbnail;
    #displayArchPagination;
    #largeImages;
    #activeSlide;

    connectedCallback() {
      this.#highlightSelectedThumbnail = this.hasAttribute('highlight-selected-thumbnail');
      this.#displayArchPagination = this.hasAttribute('display-arch-pagination');
      this.#largeImages = this.querySelectorAll('[ref="media[]"]');

      this.onClick = this.onClick.bind(this);
      this.querySelectorAll('.media-gallery__grid-thumbnail, .media-gallery__arch').forEach((btn) => {
        btn.addEventListener('click', this.onClick);
      });


      if (this.#highlightSelectedThumbnail || this.#displayArchPagination) {
        this.#handleScroll();
        window.addEventListener('scroll', this.#handleScroll, { passive: true });
      }
    }

    disconnectedCallback() {
      this.querySelectorAll('.media-gallery__grid-thumbnail, .media-gallery__arch').forEach((btn) => {
        btn.removeEventListener('click', this.onClick);
      });
      if (this.#highlightSelectedThumbnail || this.#displayArchPagination) {
        window.removeEventListener('scroll', this.#handleScroll, { passive: true });
      }
    }

    onClick(event) {
      const targetId = event.currentTarget.getAttribute('data-target-id');
      if (!targetId) return;
      const target = this.parentElement.querySelector(`#${CSS.escape(targetId)}`);
      if (!target) return;

      const rect = target.getBoundingClientRect();
      let absoluteTop = window.scrollY + rect.top;

      const header = document.querySelector('.header__container');
      if (header) {
        absoluteTop -= header.offsetHeight;
      }

      window.scrollTo({ top: Math.max(absoluteTop, 0), behavior: 'smooth' });
    }

    #updateActiveSlide = () => {
      let newActiveSlide = 0;

      const imageBreakpoints = [];
      let accumulatedHeight = 0;

      for (const image of this.#largeImages) {
        if (imageBreakpoints.length === 0) {
          imageBreakpoints[0] = image.offsetHeight / 2;
        } else {
          imageBreakpoints.push(accumulatedHeight + image.offsetHeight / 2);
        }
        accumulatedHeight += image.offsetHeight;
      }
      imageBreakpoints.pop();

      for (const breakpoint of imageBreakpoints) {
        if (window.scrollY >= breakpoint) {
          newActiveSlide++;
        }
      }

      newActiveSlide = Math.min(newActiveSlide, this.#largeImages.length - 1);

      if (newActiveSlide != this.#activeSlide) {
        this.#activeSlide = newActiveSlide;

        if (this.#displayArchPagination) {
          this.querySelectorAll(`[data-index]:not([data-index="${newActiveSlide}"]).media-gallery__arch--active`)
            .forEach(el => el.classList.remove('media-gallery__arch--active'));

          this.querySelector(`.media-gallery__arch[data-index="${newActiveSlide}"]`)
            .classList.add('media-gallery__arch--active');
        }

        if (this.#highlightSelectedThumbnail) {
          this.querySelectorAll(`[data-index]:not([data-index="${newActiveSlide}"]).media-gallery__grid-thumbnail--active`)
            .forEach(el => el.classList.remove('media-gallery__grid-thumbnail--active'));

          this.querySelector(`.media-gallery__grid-thumbnail[data-index="${newActiveSlide}"]`)
            .classList.add('media-gallery__grid-thumbnail--active');
        }
      }
    }

    #handleScroll = () => {
      requestAnimationFrame(this.#updateActiveSlide);
    }
  }

  customElements.define('product-gallery', ProductGallery);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    class SubscriptionUpsell extends HTMLElement {
  connectedCallback() {
    this.buyOnceRadio = this.querySelector('input[value="one_time"]');
    this.subscribeRadio = this.querySelector('input[value="subscribe"]');
    this.atcGroup = this.closest('.buy-buttons-block')?.querySelector('[data-atc-group]');
    this.buildCta = this.querySelector('[data-build-subscription]');
    this.subscriptionOption = this.querySelector('[data-subscription-option]');
    this.onetimeOption = this.querySelector('[data-onetime-option]');
    this.onChange = this.onChange.bind(this);
    [this.buyOnceRadio, this.subscribeRadio].forEach((el) => el && el.addEventListener('change', this.onChange));
    this.onChange();
  }

  disconnectedCallback() {
    [this.buyOnceRadio, this.subscribeRadio].forEach((el) => el && el.removeEventListener('change', this.onChange));
  }

  onChange() {
    const isSubscribe = this.subscribeRadio?.checked;
    if (!this.atcGroup || !this.buildCta) return;
    
    // Handle visibility
    if (isSubscribe) {
      this.atcGroup.classList.add('hidden');
      this.buildCta.classList.remove('hidden');
    } else {
      this.atcGroup.classList.remove('hidden');
      this.buildCta.classList.add('hidden');
    }
    
    // Handle border colors
    if (this.subscriptionOption && this.onetimeOption) {
      if (isSubscribe) {
        // Subscription selected
        this.subscriptionOption.classList.remove('border-grey');
        this.subscriptionOption.classList.add('border-california-cabernet');
        this.onetimeOption.classList.remove('border-california-cabernet');
        this.onetimeOption.classList.add('border-grey');
      } else {
        // One-time selected
        this.subscriptionOption.classList.remove('border-california-cabernet');
        this.subscriptionOption.classList.add('border-grey');
        this.onetimeOption.classList.remove('border-grey');
        this.onetimeOption.classList.add('border-california-cabernet');
      }
    }
  }
}

customElements.define('subscription-upsell', SubscriptionUpsell);
  } catch(e) { console.error(e); }
})();

})();
